const DEFAULT_PUBLIC_ORIGIN = 'https://app.prysme.eu';

export function isLocalhostUrl(url) {
  const raw = String(url ?? '').trim();
  if (!raw) return false;
  try {
    const host = new URL(raw, DEFAULT_PUBLIC_ORIGIN).hostname.toLowerCase();
    return host === 'localhost' || host === '127.0.0.1' || host === '::1' || host === '0.0.0.0';
  } catch {
    const low = raw.toLowerCase();
    return low.includes('localhost') || low.includes('127.0.0.1');
  }
}

function publicOriginFallback() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    const o = window.location.origin;
    if (!isLocalhostUrl(o)) return o;
  }
  return DEFAULT_PUBLIC_ORIGIN;
}

/** URL pleine vue tutoriel : ignore tout full_view_url localhost. */
export function resolveTutorialFullViewOpenUrl({ fullViewUrl, tutorialId, step }) {
  const tid = String(tutorialId ?? '').trim();
  const fv = String(fullViewUrl ?? '').trim();
  const base = fv && !isLocalhostUrl(fv)
    ? fv.split('?')[0].replace(/\/$/, '')
    : `${publicOriginFallback()}/aide/tutoriel/${encodeURIComponent(tid)}`;
  const stepNum = Number(step);
  const stepOk = Number.isFinite(stepNum) && stepNum >= 1;
  return stepOk ? `${base}?step=${encodeURIComponent(String(Math.floor(stepNum)))}` : base;
}
